import RadioSlider from './RadioSlider.component';

export default RadioSlider;
